var React = require('react');

function BlueskyLogo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M351.121 315.106C416.241 363.994 486.281 463.123 512 516.315C537.719 463.123 607.759 363.994 672.879 315.106C719.866 279.83 796 252.536 796 339.388C796 356.734 786.055 485.101 780.222 505.943C759.947 578.396 686.067 596.876 620.347 585.691C735.222 605.242 764.444 670.002 701.333 734.762C581.473 857.754 529.061 703.903 515.631 664.481C513.169 657.254 512.017 653.873 512 656.748C511.983 653.873 510.831 657.254 508.369 664.481C494.939 703.903 442.527 857.754 322.667 734.762C259.556 670.002 288.778 605.242 403.653 585.691C337.933 596.876 264.053 578.396 243.778 505.943C237.945 485.101 228 356.734 228 339.388C228 252.536 304.134 279.83 351.121 315.106Z","fill":"currentColor"}));
}

BlueskyLogo.defaultProps = {"width":"16","height":"16","viewBox":"200 200 624 624","fill":"none"};

module.exports = BlueskyLogo;

BlueskyLogo.default = BlueskyLogo;
